import PaymentSubscriptionModel from './PaymentSubscription';
import AccountInfoModel from './AccountInfo';
import type { RenterPaymentDetailsInterface, RenterPaymentDetailsNumericInputInterface } from './Types';

const PaymentDetailsModel = (
  paymentDetails: RenterPaymentDetailsNumericInputInterface,
): RenterPaymentDetailsInterface => {
  const {
    paymentMethodStatus = '',
    accountLast4 = '',
    accountName = '',
    accountType = '',
    createdThrough = '',
    paymentSubscriptionDetails = {
      amount: 0,
      firstScheduledDate: 0,
      nextArrivalDate: 0,
      nextScheduledDate: 0,
      recurring: false,
      paymentMethodId: '',
    },
    accountInfo = {
      accountName: '',
      accountType: '',
      accountLast4: '',
      createdThrough: '',
    },
  } = paymentDetails || {};

  return {
    paymentMethodStatus: String(paymentMethodStatus),
    accountLast4: accountLast4 && String(accountLast4),
    accountName,
    accountType,
    createdThrough,
    paymentSubscriptionDetails: paymentSubscriptionDetails && PaymentSubscriptionModel(paymentSubscriptionDetails),
    accountInfo: accountInfo && AccountInfoModel(accountInfo),
  };
};

export default PaymentDetailsModel;
